{
  "encuestasatisfaccion": {
    "preguntas": {
      "atencion": "¿Do you feel satisfied with the attention and information provided at the time of your arrival in the different reception areas of the Dhara Clinic?",
      "instalaciones": "¿Does the physical facilities of the clinic, the order and cleanliness meet your needs and expectations? ",
      "informacion": "¿Did you receive sufficient, understandable and your stay at the Dhara Clinic? prompty information during your stay at the Dhara Clinic?",
      "atencion_salas": "¿Se siente satisfecho(a) con la atención recibida en salas de cirugía?",
      "atencion_hospitalizacion": "¿Do you feel satisfied with the care received in hospitalization?",
      "horario_programado": "¿Was your surgery on Schedule?",
      "alimentos": "¿Are you satisfied with the flavor and presentation of the food received?",
      "derechos_deberes": "¿Did you received information of your rights and duties as a patient?",
      "experiencia_global": "¿How would you qualify your experience regarding the health services you have received through this Clinic?",
      "recomendacion": "¿Would you recommend this Clinic to your family and Friends?"
    },
    "opciones": {
      "SI": "Yes",
      "NO": "No",
      "NA": "No aplica",
      "MB": "Very good",
      "B": "Good",
      "R": "Okay",
      "M": "Bad",
      "MM": "Very bad",
      "DS": "Definitely yes",
      "PS": "Probably yes",
      "DN": "Definitely no",
      "PN": "Probably no",
      "felicitacion": "Congratulation",
      "sugerencia": "Sugestion",
      "queja": "Complaint",
      "reclamo": "Claim"
    },
    "observacion": "",
    "boton": "Guardar"
  }
}